import { useNavigate } from 'react-router-dom'
import { SiteHeader } from '../components/SiteHeader'
import { MembershipPanel } from '../components/membership/MembershipPanel'

/**
 * /account/membership — desktop.
 *
 * ── THE PATH IS NOT A PREFERENCE ──────────────────────────────────────────
 * `functions/src/billing/askaPlus.ts` hardcodes
 * `RETURN_BASE = 'https://www.thediaex.com/account/membership'` and returns
 * buyers from Stripe to `?membership=joined|cancelled`. If this route did not
 * exist, `path="*"` would redirect a buyer who has just JOINED (been charged) to
 * the home page with no confirmation — a dead end on the money path. The panel
 * reads `?membership=joined` and plays the join celebration.
 *
 * `Header` is always mounted, so Browse and the account menu are one click away
 * from every membership state.
 */
export function AccountMembership() {
  const navigate = useNavigate()
  return (
    <>
      <SiteHeader />
      <main className="min-h-[60vh] pb-16">
        <MembershipPanel onBack={() => navigate('/search')} />
      </main>
    </>
  )
}
